import { useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import TrackOverviewModalContainer from '../../../containers/TracksPage/TrackOverviewModalContainer';
import LessonOverviewModalContainer from '../../../containers/LessonsPage/LessonOverviewModalContainer';
import { useOverviewNavigation } from '../overviewRouting';
import { ShortOverviewModal } from './ShortOverviewModal';
import { useSetLastClickedMLRecommendationItemFromUrl } from '../../../features/recommendations/recommendationsHooks';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { useTheme } from 'foundations-theming/utils';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { OVERVIEW_MAX_CONTENT_WIDTH } from './OverviewContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewModal = ({
  source,
  type,
  entityId,
  language
}) => {
  const {
    closeOverview
  } = useOverviewNavigation();
  useSetLastClickedMLRecommendationItemFromUrl({
    id: entityId,
    type
  });
  const handleClose = () => {
    UsageTracker.track('interaction', Object.assign({
      action: 'overview-modal-close',
      appearsIn: source
    }, type === 'TRACK' && {
      trackId: entityId
    }, type === 'LESSON' && {
      lessonId: entityId
    }, type === 'SHORT_FORM_CONTENT' && {
      shortId: entityId
    }, {
      language
    }));
    closeOverview();
  };
  useEffect(() => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-view',
      contentId: `${entityId}`,
      contentType: type,
      appearsIn: source
    });
  }, [source, entityId, type]);
  const theme = useTheme();
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "overview-modal",
    dialogStyles: {
      blockSize: isMobile ? undefined : `calc(100% - ${theme.space['1300']})`,
      marginBlockStart: isMobile ? undefined : '1300',
      marginInline: 'auto',
      maxInlineSize: `${OVERVIEW_MAX_CONTENT_WIDTH}px`
    },
    use: "fullscreen",
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      color: "icon-core-on-fill-default",
      "data-test-id": "overview-close-button",
      detached: true,
      onClick: handleClose,
      size: "lg"
    }), /*#__PURE__*/_jsx(DialogBody, {
      padding: "0",
      children: type === 'SHORT_FORM_CONTENT' ? /*#__PURE__*/_jsx(ShortOverviewModal, {
        shortId: entityId,
        source: source
      }) : type === 'TRACK' ? /*#__PURE__*/_jsx(TrackOverviewModalContainer, {
        language: language,
        source: source,
        trackId: entityId
      }) : /*#__PURE__*/_jsx(LessonOverviewModalContainer, {
        language: language,
        lessonId: entityId,
        source: source
      })
    })]
  });
};
export default OverviewModal;